module.exports = __webpack_public_path__ + "img/chrome.bdde6e51.png";